import { Component, Prop, h } from '@stencil/core';

@Component({
  tag: 'spw-table-header',
  styleUrl: 'spw-table-header.scss',
  shadow: true,
})
export class SpwTableHeader {
  /** Définit un colspan pour la cellule */
  @Prop() colspan?: HTMLTableCellElement['colSpan'];
  /** Définit un header relationnel pour la cellule, à des fins d'accessibilité */
  @Prop() headers?: HTMLTableCellElement['headers'];
  /** Définit un rowspan pour la cellule */
  @Prop() rowspan?: HTMLTableCellElement['rowSpan'];
  /** Définit un style visuel qui met en avant la cellule */
  @Prop() isHighlighted?: boolean = false;
  /** Définit un alignement de texte pour la cellule */
  @Prop() textAlign?: 'center' | 'left' | 'right' = 'left';
  /** Définit un alignement vertical pour la cellule */
  @Prop() verticalAlign?: 'top' | 'bottom' | 'middle' = 'top';

  private get elementClass(): { [className: string]: boolean } {
    return {
      'spw-table-header': true,
      [`spw-table-header--text-align-${this.textAlign}`]: true,
      [`spw-table-header--vertical-align-${this.verticalAlign}`]: true,
    };
  }

  render() {
    return (
      <th class={this.elementClass} colSpan={this.colspan} headers={this.headers} part="cell" rowSpan={this.rowspan}>
        <slot />
      </th>
    );
  }
}
